import { render, staticRenderFns } from "./StatisticProjectReportsBlankPDF.vue?vue&type=template&id=efbab9a6&"
import script from "./StatisticProjectReportsBlankPDF.vue?vue&type=script&lang=js&"
export * from "./StatisticProjectReportsBlankPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports